import { MarkovVariable } from "server/models"
import { OrderType } from "client/utils"

export interface MarkovVariableProps {
    variableId: number
}

export interface MarkovVariableList { [variableId: number]: MarkovVariable }
export interface MarkovVariableListByName { [name: string]: MarkovVariable }
export type MarkovVariableValidation = { [key in keyof MarkovVariable]?: string}

export interface MarkovVariableFilters {
    search?: string
}

export interface MarkovVariableState {
    variableList: MarkovVariableList
    variableListByName: MarkovVariableListByName
    variableIds: readonly number[]
    variableEdit: MarkovVariable

    variableDelete: MarkovVariable

    sortColumn: keyof MarkovVariable
    sortOrder: OrderType
    filters: MarkovVariableFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const MARKOV_VARIABLE_LIST = "MARKOV_VARIABLE_LIST"
export const MARKOV_VARIABLE_IDS = "MARKOV_VARIABLE_IDS"
export const MARKOV_VARIABLE_EDIT = "MARKOV_VARIABLE_EDIT"

export const MARKOV_VARIABLE_DELETE = "MARKOV_VARIABLE_DELETE"
export const MARKOV_VARIABLE_SORT = "MARKOV_VARIABLE_SORT"
export const MARKOV_VARIABLE_FILTERS = "MARKOV_VARIABLE_FILTERS"

export const MARKOV_VARIABLE_RELOAD_LIST = "MARKOV_VARIABLE_RELOAD_LIST"
export const MARKOV_VARIABLE_RELOAD_EDIT = "MARKOV_VARIABLE_RELOAD_EDIT"
